module.exports = __webpack_public_path__ + "assets/img/travel1.1e30aff9.png";